import {useMutation, useQuery} from '@tanstack/react-query';
import {apiClient, queryClient} from '@common/http/query-client';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import { showHttpErrorToast } from '@common/utils/http/show-http-error-toast';



const endpoint = (report_id: number | string) => `${report_id}/download-demo-uw-pdf`;

interface Response extends BackendResponse {}

interface Payload {
  report_id: number | string;
}

export function useDownloadPdf() {

  return useMutation({
    mutationFn: (payload: Payload) => downloadPdf(payload),
    onError: err => showHttpErrorToast(err),
  });
}

function downloadPdf({report_id}: Payload): Promise<Response> {
  return apiClient.post(endpoint( report_id), {}, {responseType: 'blob'}).then(r => r.data);
}

export function downloadFile(fileName: string, blob: any) {
  // Create blob link to download
  const url = window.URL.createObjectURL(
    new Blob([blob]),
  );
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute(
    'download',
    fileName,
  );

  // Append to html link element page
  document.body.appendChild(link);

  // Start download
  link.click();

  // Clean up and remove the link
  link.parentNode?.removeChild(link);
}